import { render, staticRenderFns } from "./SellIn.vue?vue&type=template&id=4ba2f2a8&lang=html&"
import script from "./SellIn.vue?vue&type=script&lang=js&"
export * from "./SellIn.vue?vue&type=script&lang=js&"
import style0 from "./SellIn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/sell-in/SellIn.vue
// module id = 1468
// module chunks = 28